import type { ListOut } from "Types/beListApi";

export interface PaginationState {
  pageNumber: number;
  pageSize: number;
  totalItems: number;
  orderBy: "Id" | "Name" | "GroupType";
  orderDescending: boolean;
  loading: boolean;
}

export type SearchGroupType = "All" | "Normal" | "Test" | "Form";

export interface SearchState {
  groupType: SearchGroupType;
  searchBy: string;
}

export type GroupType =
  | "Normal"
  | "Test"
  | "Form"
  | "ChangedEmail"
  | "SocialPlus"
  | "Temporary";

export interface GroupItem {
  Id: number;
  IdList: number;
  Name: string;
  Notes: string;
  Deleteable: boolean;
  Type: GroupType;
  IdGroups?: number[];
}

export const groupTypeLabelMap: Record<GroupType, string> = {
  Normal: "Load.GroupsList.GroupTypeNormal",
  Test: "Load.GroupsList.GroupTypeTest",
  Form: "Load.GroupsList.GroupTypeForm",
  ChangedEmail: "Load.GroupsList.GroupTypeChangedEmail",
  SocialPlus: "Load.GroupsList.GroupTypeSocialPlus",
  Temporary: "Load.GroupsList.GroupTypeTemporary",
};

export type GroupOperation =
  | "DeleteGroup"
  | "DeleteRecipients"
  | "DeleteGroupAndRecipients"
  | "EmptyGroup";

export type ModalDeleteState =
  | {
      show: false;
      op?: GroupOperation;
      items?: GroupItem[];
    }
  | {
      show: true;
      op: GroupOperation;
      items: GroupItem[];
    };

export interface PanelEditState {
  show: boolean;
  item?: GroupItem;
  nameIsDirty: boolean;
  nameConflict: boolean;
}

export const modalDeleteTitleMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.GroupsList.ModalDeleteGroupTitle",
  DeleteRecipients: "Load.GroupsList.ModalDeleteRecipientsTitle",
  DeleteGroupAndRecipients:
    "Load.GroupsList.ModalDeleteGroupAndRecipientsTitle",
  EmptyGroup: "Load.GroupsList.ModalEmptyGroupTitle",
};

export const modalDeleteDescriptionMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.GroupsList.ModalDeleteGroupDescription",
  DeleteRecipients: "Load.GroupsList.ModalDeleteRecipientsDescription",
  DeleteGroupAndRecipients:
    "Load.GroupsList.ModalDeleteGroupAndRecipientsDescription",
  EmptyGroup: "Load.GroupsList.ModalEmptyGroupDescription",
};

export const modalDeleteMultiTitleMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.GroupsList.ModalDeleteMultiGroupTitle",
  DeleteRecipients: "Load.GroupsList.ModalDeleteMultiRecipientsTitle",
  DeleteGroupAndRecipients:
    "Load.GroupsList.ModalDeleteMultiGroupAndRecipientsTitle",
  EmptyGroup: "Load.GroupsList.ModalEmptyMultiGroupTitle",
};

export const modalDeleteMultiDescriptionMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.GroupsList.ModalDeleteMultiGroupDescription",
  DeleteRecipients: "Load.GroupsList.ModalDeleteMultiRecipientsDescription",
  DeleteGroupAndRecipients:
    "Load.GroupsList.ModalDeleteMultiGroupAndRecipientsDescription",
  EmptyGroup: "Load.GroupsList.ModalEmptyMultiGroupDescription",
};

export const notifyDeleteSuccessMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.MailupCommon.Deleted",
  DeleteRecipients: "Load.GroupsList.DeleteRecipientsSuccess",
  DeleteGroupAndRecipients: "Load.GroupsList.DeleteGroupAndRecipientsSuccess",
  EmptyGroup: "Load.GroupsList.EmptyGroupSuccess",
};

export const notifyDeleteSuccessMultiMap: Record<GroupOperation, string> = {
  DeleteGroup: "Load.MailupCommon.DeletedPlural",
  DeleteRecipients: "Load.GroupsList.DeleteRecipientsSuccess",
  DeleteGroupAndRecipients:
    "Load.GroupsList.DeleteGroupAndRecipientsMultiSuccess",
  EmptyGroup: "Load.GroupsList.EmptyGroupMultiSuccess",
};

export interface GroupStats {
  IdGroup: number;
  EmailSubscribed: number;
  EmailPending: number;
  EmailUnsubscribed: number;
  SmsSubscribed: number;
  SmsPending: number;
  SmsUnsubscribed: number;
}
export interface GroupsStatsState {
  stats: GroupStats[];
  loading: boolean;
}

export interface ModalCopyState {
  show: boolean;
  step: "form" | "confirm";
  group?: GroupItem;
  newList?: ListOut;
  newName: string;
  nameValid: boolean;
  nameValidLoading: boolean;
}
